import { render, staticRenderFns } from "./fee.vue?vue&type=template&id=4f8a0162&"
import script from "./fee.vue?vue&type=script&lang=js&"
export * from "./fee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports